var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9072 17.1538V17.9231C11.9072 18.7391 11.6009 19.5218 11.0558 20.0988C10.5107 20.6758 9.77143 21 9.00054 21C8.22966 21 7.49035 20.6758 6.94525 20.0988C6.40015 19.5218 6.09392 18.7391 6.09392 17.9231V17.1538M16.7976 15.588C15.6313 14.0769 14.8079 13.3077 14.8079 9.14183C14.8079 5.32692 12.9676 3.96779 11.453 3.30769C11.2518 3.22019 11.0624 3.01923 11.0011 2.80048C10.7354 1.84327 9.99061 1 9.00054 1C8.01047 1 7.2652 1.84375 7.00224 2.80144C6.94093 3.0226 6.75154 3.22019 6.55035 3.30769C5.03391 3.96875 3.19547 5.32308 3.19547 9.14183C3.19319 13.3077 2.3698 14.0769 1.20352 15.588C0.720291 16.2139 1.14357 17.1538 1.98876 17.1538H16.0169C16.8575 17.1538 17.2781 16.2111 16.7976 15.588Z",
    stroke: "#297FCA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.52c52fa6478312a7d447f922d8e304fb.svg";
export { ForwardRef as ReactComponent };